import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';

export const dataRows = (index: number, style: TxpStyle, text: string): JSX.Element => {
    return (
        <label key={index} className={index !== 0 ? style.summaryLabel : null}>
            {text}
        </label>
    );
};
